/**
 * All functions associated with firebase authentication reside here.
 */

// Firebase
import { fbAuth } from "./firebase";

// export const authUi = new firebaseui.auth.AuthUI(fbAuth);

/*
// Authenticate via google signin
export const callAuth = () => {
  // SignIn with Popup
  fbAuth
    .signInWithPopup(provider)
    .then(function (result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // var token = result.credential.accessToken;
      // var user = result.user;
      console.log("Google Auth Success=====", result);
    })
    .catch(function (error) {
      // Handle Errors here.
      // var email = error.email;
      console.error("Google Auth ERROR=====", error);
    });
};
*/

// Auth state change
export const checkAuth = (getAuthDetails, removeAuthDetails, authLoading) => {
  authLoading();
  fbAuth.onAuthStateChanged(function (user) {
    if (user) {
      console.log("authStateChanged:=====", user);
      getAuthDetails(user);
    } else {
      console.log("authStateChanged: no user logged in.");
      removeAuthDetails();
    }
  });
};

// Signout the user
export const callUnauth = () => {
  fbAuth
    .signOut()
    .then(function () {
      console.log("User signed out.");
    })
    .catch(function (error) {
      console.error("Error on signout===", error);
    });
};

// Delete a user
export const delCurrentUser = () => {
  // setAuthLoading();
  var user = fbAuth.currentUser;
  if (user) {
    user
      .delete()
      .then(function () {
        console.log("User deleted.");
        // resetAuthDetailsAction();
        // ui.start("#firebaseui_container", uiConfig);
      })
      .catch(function (error) {
        console.error("An error happened while deleting user===", error);
      });
  }
};
